let arr=[
    {name:'屠宰场',value:'屠宰场'},
    {name:'商超',value:'商超'},
    {name:'农贸市场',value:'农贸市场'},
    {name:'生鲜乳收购站',value:'生鲜乳收购站'},
    {name:'生鲜乳运输环节',value:'生鲜乳运输环节'},
    {name:'养殖环节',value:'养殖环节'},
    {name:'批发市场',value:'批发市场'},
    {name:'生产基地/企业',value:'生产基地/企业'},
    {name:'其他',value:'其他'}
]
export default arr